<template>
  <v-layout row justify-center>
   <v-navigation-drawer
      width="620"
      v-model="invoiceoftransaction"
      temporary
      fixed
      right
      clipped
      disable-resize-watcher
      app
    >
          <v-btn flat small class="green-darken-text" @click="invoiceoftransaction = false">
            <v-icon>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
          <v-spacer></v-spacer>
        <v-flex xs12>
          <p class="font-size-20-bold" align="center" >Invoice</p>
        </v-flex>
        <v-layout px-4 v-if="!mobileView">
          <v-flex xs3>
            <p class="font-size-14 font-roboto" style="margin:0px 0px 0px;" align="left">
              Company Name
            </p>
          </v-flex>
          <v-flex xs3 px3>
            <p class="font-size-14 font-roboto" align="left">
              <strong>{{invoicedatail.Customer_name}}</strong>&nbsp;&nbsp;
            </p>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs2>
            <p class="font-size-14 font-roboto" align="left">
              Invoice No &nbsp;&nbsp;
            </p>
          </v-flex>
          <v-flex xs3>
            <p class="font-size-14-bold font-roboto" align="right">
              <strong>{{invoicedatail.Invoice_no}}</strong>
            </p>
          </v-flex>
        </v-layout>

        <v-layout px-4 v-if="!mobileView">
          <v-flex xs3>
            <p class="font-size-14 font-roboto" align="left" >
              Tax ID &nbsp;&nbsp;
            </p>
          </v-flex>
          <v-flex xs3 px3>
            <p class="font-size-14 font-roboto" align="left">
              <strong>{{ invoicedatail.taxid }}</strong>&nbsp;&nbsp;
            </p>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs2 >
            <p class="font-size-14 font-roboto" align="left">
              Invoice Date&nbsp;&nbsp;
            </p>
          </v-flex>
          <v-flex xs3>
            <p class="font-size-14-bold font-roboto" align="right">
              <strong>{{ invoicedatail.Document_date }}</strong>
            </p>
          </v-flex>
        </v-layout>

        <p style="font-size:14px; font-family:'Roboto'; margin-left:20px;" align="left" v-if="mobileView">
              Company Name : <strong class="green-darken-text font-roboto">{{invoicedatail.Customer_name}}</strong> <br>
              Tax ID : <strong class="green-darken-text font-roboto">{{ invoicedatail.taxid }}</strong><br>
              Invoice No : <strong class="green-darken-text font-roboto">{{invoicedatail.Invoice_no}}</strong><br>
              Invoice Date : <strong class="green-darken-text font-roboto">{{ invoicedatail.Document_date }}</strong>
            </p>
        <v-layout align-center justify-center row wrap>
          <v-flex xs11 py-3>
            <v-data-table
              :headers="tablelistheaders"
              :items="itemlistview"
              hide-actions
              class="elevation-3"
              id="tableDetail"
            >
              <template v-slot:items="props" >
                <tr>
                  <td data-label="No." >{{ props.index + 1}}</td>
                  <td data-label="Description"  class="longtext">{{ props.item.Item_description }}</td>
                  <td data-label="Unit Amount" >{{ props.item.Item_AmountExcVat }}</td>
                  <td data-label="Quantity">{{ props.item.Quantity }}</td>
                  <td data-label="Amount">{{ props.item.Item_AmountExcVat }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-layout align-center justify-end row wrap px-4>
            <v-flex xs10 py-3 px-2>
              <p class="font-size-14" align="right">
                Subtotal (THB) &nbsp;&nbsp;
                <br />
                VAT (THB) &nbsp;&nbsp;
                <br />
                Withholding Tax ({{invoicedatail.wht_rate}}%) &nbsp;&nbsp;
                <br />
                <strong >Total (THB) &nbsp;&nbsp;</strong>
              </p>
            </v-flex>
            <v-flex xs2 py-4 px-1>
              <p class="font-size-14" align="right">
                {{ this.addCommas(parseFloat(invoicedatail.Invoice_Amount).toFixed(2)) }}
                <br />
                {{ this.addCommas(parseFloat(invoicedatail.Vat_amount).toFixed(2)) }}
                <br />
                {{ this.addCommas(parseFloat(invoicedatail.wht_amount).toFixed(2)) }}
                <br />
                <strong>{{ this.addCommas(parseFloat(invoicedatail.InvoiceamountWithVat).toFixed(2)) }}</strong>
              </p>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-flex pb-3></v-flex>
    </v-navigation-drawer>
    <!-- <Transactionmodal /> -->
  </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'
import moment from 'moment'
// import transactionmodal from '@/components/transactionmodal'
moment.locale('en')
export default {
  components: {
    // transactionmodal
  },
  data () {
    return {
      mobileView: false,
      drawer: false,
      dialogloader: true,
      notifications: false,
      sound: true,
      widgets: false,
      trannum: '',
      invoicedatail: { item_list: [] },
      tablelistheaders: [
        { text: 'No.', value: 'index', sortable: false, align: 'center' },
        {
          text: 'Description',
          value: 'Item_description',
          sortable: false,
          align: 'center'

        },
        {
          text: 'Unit Amount',
          value: 'Item_AmountExcVat',
          sortable: false,
          align: 'center'
        },
        { text: 'Quantity', value: 'Quantity', sortable: false, align: 'center' },
        {
          text: 'Amount',
          value: 'Item_AmountExcVat',
          sortable: false,
          align: 'center'
        }
      ],
      paymenttoken: ''
    }
  },
  methods: {
    async getinvoicedetails () {
      try {
        if (this.currentinvoiceno) {
          this.dialogloader = true
          let { data } = await this.axios.get(`${process.env.VUE_APP_APIHOST}/invoice_details/` + this.currentinvoiceno, {
            headers: {
              Authorization: this.$cookies.get('token')
            }
          })
          // console.log('/inv of tran: ', data);
          data.Document_date = moment(data.Document_date).format('D MMMM YYYY')
          this.invoicedatail = data
          this.dialogloader = false
        }
      } catch (error) {
        this.istableloading = false
        console.log(error.message)
      }
    },
    addCommas (nStr) {
      nStr += ''
      var x = nStr.split('.')
      var x1 = x[0]
      var x2 = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
      }
      return x1 + x2
    },
    handleView () {
      this.mobileView = window.innerWidth <= 990
    }
  },
  computed: {
    invoiceoftransaction: sync('invoiceoftransaction'),
    transactionmodal: sync('transactionmodal'),
    currentinvoiceno: sync('currentinvoiceno'),
    currenttransaction: sync('currenttransaction'),
    itemlistview () {
      return this.invoicedatail.item_list.map(item => {
        return {
          ...item,
          Item_AmountExcVat:
            this.addCommas(item.Item_AmountExcVat.toFixed(2)) + ' THB'
          // Item_AmountIncVat:
          //   this.addCommas(item.Item_AmountIncVat.toFixed(2)) + ' THB'
        }
      })
    },
    detailview () {
      return Object.keys(this.invoicedatail)
        .filter(
          key =>
            ![
              'SO_Number',
              'Invoice_no',
              'invoice_description',
              'item_list'
            ].includes(key)
        )
        .reduce((obj, key) => {
          obj[key] = this.invoicedatail[key]
          return obj
        }, {})
    },
    paymenturl () {
      return process.env.VUE_APP_PAYMENTURL
    }
  },
  created () {
    this.dialogloader = false
    this.getinvoicedetails()
    this.handleView()
  },
  watch: {
    currentinvoiceno () {
      this.getinvoicedetails()
    }
  }
}
</script>

<style>
#tableDetail tr:nth-child(even){
    background-color: #f1fcf1;
  }
</style>
